import api from "../../../api";
import {typedQuery} from "../../typing";

export const engagementTemplates = typedQuery(["tprm", "engagementTemplates"], async () => {
  return await api.tprm.engagementTemplates.list();
});
